import { render } from "./DataContent.vue?vue&type=template&id=5fa6c08c&scoped=true"
import script from "./DataContent.vue?vue&type=script&lang=js"
export * from "./DataContent.vue?vue&type=script&lang=js"

import "./DataContent.vue?vue&type=style&index=0&id=5fa6c08c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa6c08c"]])

export default __exports__